/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IDeleteUserMethods,
  DeleteUserService,
  IReInviteUserMethods,
  ReInviteUserService,
  ISuspendUserMethods,
  SuspendUserService,
  ActivateUserService,
  IActivateUserMethods,
  IPackerListMethods,
  PackerListService,
  IInvitePackerMethods,
  InvitePackerService
} from "./components";

export type PackerPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IReInviteUserMethods &
  ISuspendUserMethods &
  IActivateUserMethods &
  IDeleteUserMethods &
  IPackerListMethods & IInvitePackerMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new DeleteUserService(),
    new ReInviteUserService(),
    new SuspendUserService(),
    new ActivateUserService(),
    new PackerListService(),
    new InvitePackerService(),
  ];
};

export const getAgent = () => {
  return createAgent<PackerPageAgent>({
    plugins: getPlugins(),
  });
};
